import { render, staticRenderFns } from "./DealOrganizeTransportDialog.vue?vue&type=template&id=5bb95d6a&scoped=true"
import script from "./DealOrganizeTransportDialog.vue?vue&type=script&lang=js"
export * from "./DealOrganizeTransportDialog.vue?vue&type=script&lang=js"
import style0 from "./DealOrganizeTransportDialog.vue?vue&type=style&index=0&id=5bb95d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb95d6a",
  null
  
)

export default component.exports